import { Fragment, useEffect, useState, useContext } from "react";
import DataTable from "react-data-table-component";
import {Link} from 'react-router-dom';
import API from '../../../config/API';
import {EntornoGlobal} from '../../../config/globalContext';
import {arrayToCsv, downloadCSV} from '../../../helpers/arraytoCSV';
import Loading from '../../theme/loading';


const ListMaterialOntology = () => {

  const [state, setState] = useState({ status : "loading", ontologies: [], search: "" })
  const [statecnx, setStateCnx] = useContext(EntornoGlobal);

  useEffect(()=>{
    API.get('/v3/api/materialOntology', {}).then((data)=>{
      if(Array.isArray(data)){

        const parse_data = data.map( (e) => {
            
            const name = Object.keys(e)[0];

            return {
                name: name,
                r: e[name].r,
                g: e[name].g,
                b: e[name].b,
                rgb: e[name].r+", "+e[name].g+", "+e[name].b,
                nirReflectance: e[name].nirReflectance,
                nirOpacity: e[name].nirOpacity,
            }

        })

        setState({status:"loaded", ontologies:parse_data, search:""});
      }else{
        setState({status:"error", message: "You don't have permissions"});
      }
    });
  },[]);

  const filtersOntology = () => {

    return state.ontologies.filter((e)=>{
      
      const row = (e.name).toLowerCase();

      return (row.indexOf(state.search.toLowerCase()) !== -1?true:false);

    });

  }

  const download = () => {

    // Parse ontology
      let parse = state.ontologies.map( row =>
        [`"${row.name}"`, `"${row.rgb}"`]
      )

    // Add header
      parse = [["name", "RGB", "NIR_Reflectance", "NIR_Opacity"]].concat(parse);

    let csv = arrayToCsv(parse);

    const name = "material-ontology-"+new Date().toISOString().split('T')[0]+".csv";

    downloadCSV(csv, name, 'text/csv;charset=utf-8;')
    
  }

  const columns = [
    { name: 'Name', selector: row => (<Link to={"/app/materialOntology/edit/"+row.name}>{row.name}</Link>), sortable: true },
    { name: 'Color', selector: row => (<Link to={"/app/materialOntology/edit/"+row.name}>{"rgb("+row.r+", "+row.g+", "+row.b+")"}</Link>), },
    { name: 'Color', selector: row => (<Link to={"/app/materialOntology/edit/"+row.name} style={{color: "rgb("+row.r+", "+row.g+", "+row.b+")"}}><div>████████████</div></Link>), },
    { name: 'NIR Reflectance', selector: row => (<Link to={"/app/ontology/edit/"+row.name}><div>{(row.nirReflectance)}</div></Link>), },
    { name: 'NIR Opacity', selector: row => (<Link to={"/app/ontology/edit/"+row.name}><div>{(row.nirOpacity)}</div></Link>), }
  ];

  if(statecnx?.user?.permissions.ontology.material.write){ columns.push({ name: 'Actions', selector: (row) => (<Link to={"/app/materialOntology/edit/"+row.name}>Edit material ontology registry</Link>), }); }

  if(state.status === "loading"){ return <Loading /> }

  return(
    <div>
      <div className="row">
        <div className="col-md-6">
          <h2>Ontology</h2>
        </div>
        <div className="col-md-6 text-end">
          {(statecnx?.user?.permissions.ontology.material.write &&
            <Link to="/app/materialOntology/add"><button className="btn btn-success">Add material ontology registry</button></Link>
          )}
        </div>
      </div>
      
      <div className="row mt-3 mb-3">
        <div className="col-md-12">
          <input type="text" className="form-control" onChange={(e)=>{ setState({...state, search: e.target.value})}} placeholder="Search..." />
        </div>
      </div>

      {(state.status==='error'&&<div className="alert alert-danger">{state.message}</div>)}

      {(state.status==='loaded'&&<DataTable
            columns={columns}
            data={filtersOntology(state.ontology)}
        />)}

        <div className="text-end">
          <button className="btn btn-info mt-3 mb-3" onClick={download}>Download material ontology CSV</button>
        </div>


    </div>
  )
};

export default ListMaterialOntology;